angular.module('app').component('testAttachments', {
    bindings: {
        attachments: '<', // AttachmentModel[]
        attachmentType: '@', // string => AttachmentType
        selectedItems: '<' // selectedItemsModel
        // TODO: update: initially false then true
    },
    controllerAs: 'vm',
    templateUrl: 'scripts/app/partials/TraceDetails/TestAttachments/test-attachments.tpl.html',
    controller: function ($window, $timeout, moment, $uibModal, $confirm, Upload, UserDetailsApi, TraceDetailsServiceApi, SettingsExService, ViewMediaModalService, toastr, ApiErrorService) {
        let vm = this;
        vm.uploadReceipts = uploadReceipts;
        vm.downloadMedia = downloadMedia;
        vm.showMedia = showMedia;
        vm.deleteConfirmation = deleteConfirmation;
        // controller level variables
        let attachments;
        let attachmentType;
        let selectedItems;
        let user;
        let maxUploadMb;
        let InvalidUploadExtensions;
        // view model flags
        vm.showReceipts = false;
        vm.receiptProgress = -1;
        vm.logProgress = -1;
        vm.errorMsg = null;
        vm.caption = '';
        vm.$onInit = function () {
            UserDetailsApi.get().then(function (response) {
                user = response.data;
                vm.user = user;
            });
            SettingsExService.get().then(function (response) {
                let appSettings = response;
                InvalidUploadExtensions = appSettings.InvalidUploadExtensions.split(',');
                maxUploadMb = appSettings.MaxUploadMb;
                vm.maxUploadMb = maxUploadMb;
            });
            if (this.attachmentType === 'receipt') {
                vm.caption = 'Receipts';
            }
            if (this.attachmentType === 'log') {
                vm.caption = 'Reports';
            }
            $window.vm = this;
        };
        this.$onChanges = function (changes) {
            if (changes.attachments) {
                attachments = this.attachments;
                vm.attachments = attachments;
            }
            if (changes.attachmentType) {
                attachmentType = this.attachmentType;
                vm.attachmentType = attachmentType;
            }
            if (changes.selectedItems) {
                selectedItems = this.selectedItems;
                vm.selectedItems = selectedItems;
            }
        };
        function uploadReceipts(files) {
            let fac = checkFileSizes(files);
            vm.tooLargeReceipts = fac.tooLarge;
            vm.validReceipts = fac.validFiles;
            // TODO: Check the case on the server
            if (checkValidExtension(files)) {
                uploadFiles(attachmentType, fac.validFiles);
            }
            else {
                toastr.error('Invalid file upload extension');
            }
        }
        function checkValidExtension(files) {
            let result = true;
            for (let i = 0; i < files.length; i++) {
                let fileExtension = '';
                fileExtension = files[i].name.split('.').pop();
                if (InvalidUploadExtensions.indexOf(fileExtension.trim()) > -1) {
                    result = false;
                }
            }
            return result;
        }
        function uploadFiles(attachmentType, files) {
            if (angular.isUndefined(files)) {
                return;
            }
            // NOTE: requestDto must be scoped to the function not the if block
            let requestDto;
            if (files.length > 0) {
                requestDto = {
                    SimId: selectedItems.selectedSim.Id,
                    UserId: selectedItems.selectedTester.Id,
                    ProjectIterationId: selectedItems.projectIterationId,
                    SuiteId: selectedItems.selectedSuite.Id,
                    TestId: selectedItems.selectedTest.Id,
                    UploadType: attachmentType,
                    Files: files
                };
                Upload.upload({
                    method: 'POST',
                    url: 'api/UTPAttachment/FileUpload',
                    data: requestDto,
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).progress((evt) => {
                    let progress = Math.min(100, Math.round(100.0 * evt.loaded / evt.total));
                    if (attachmentType === 'receipt') {
                        vm.receiptProgress = progress;
                    }
                    if (attachmentType === 'log') {
                        vm.logProgress = progress;
                    }
                }).then(function (response) {
                    // NOTE: MtTraceDetails.onNewAttachments will repopulate the attachments list.
                    // All we need to do here is show the new stuff and stop the progress indicator
                    if (response.status === 200) {
                        // success
                        vm.showReceipts = true;
                        $timeout(function () {
                            vm.receiptProgress = -1;
                            vm.logProgress = -1;
                        });
                    }
                    else {
                        // failure
                        ApiErrorService.error(response);
                        vm.receiptProgress = -1;
                        vm.logProgress = -1;
                    }
                }).catch(function (error) {
                    ApiErrorService.error(error);
                    vm.receiptProgress = -1;
                    vm.logProgress = -1;
                });
            }
        }
        function checkFileSizes(files) {
            let fac = {
                tooLarge: [],
                validFiles: []
            };
            angular.forEach(files, function (file) {
                let fileSizeMb = file.size / 1024 / 1024;
                // NOTE: maxUploadMb is a setting in web.config
                if (fileSizeMb <= maxUploadMb) {
                    fac.validFiles.push(file);
                }
                else {
                    fac.tooLarge.push(file);
                }
            });
            return fac;
        }
        function downloadMedia(media) {
            let url = ['api/download/attachment?Id=', media.Id].join('');
            $window.location.href = url;
            return;
        }
        // TODO: Find type for attachment
        function showMedia(media) {
            // Redirect to download link
            if (media.ContentSubType === 'application' &&
                media.Type !== 'Collis') {
                let url = ['api/download/attachment?Id=', media.Id].join('');
                $window.location.href = url;
                return;
            }
            // We already have the content so show it
            if (media.Content) {
                ViewMediaModalService.open(media);
                return;
            }
            // We don't have the content so go and get it then show it
            TraceDetailsServiceApi.getAttachment(media.Id).then(function (response) {
                media.Content = response.data.Content;
                ViewMediaModalService.open(media);
            });
        }
        function deleteConfirmation(media) {
            let title = `Delete ${labelForAttachmentType()}`;
            let text = `Are you sure you want to delete the ${labelForAttachmentType().toLowerCase()} ${media.FileName}?`;
            $confirm({ title, text }).then(function () {
                deleteMedia(media);
            });
        }
        function deleteMedia(media) {
            let attachmentsRequest = {
                UserId: selectedItems.selectedTester.Id,
                SimId: selectedItems.selectedSim.Id,
                SuiteId: selectedItems.selectedSuite.Id,
                TestId: selectedItems.selectedTest.Id,
                WithFileContents: false
            };
            TraceDetailsServiceApi.deleteAttachment(media.Id, attachmentsRequest).then(function (response) {
                if (response.status === 200) {
                    let dto = response.data;
                    switch (attachmentType) {
                        case 'receipt':
                            vm.attachments = dto.Receipts;
                            break;
                        case 'log':
                            vm.attachments = dto.Logs;
                            break;
                        default:
                            toastr.info('Unknown attachment type');
                    }
                    toastr.info(`${labelForAttachmentType()} ${media.FileName} has been deleted.`);
                }
                else {
                    toastr.error('An error occurred');
                }
            });
        }
        function labelForAttachmentType() {
            let labelTxt = '';
            switch (attachmentType) {
                case 'receipt':
                    labelTxt = 'Receipt';
                    break;
                case 'log':
                    labelTxt = 'Report';
                    break;
                default:
                    labelTxt = attachmentType;
            }
            return labelTxt;
        }
    }
});
